import React from 'react';
import { Routes, Route } from 'react-router-dom';
import i18n from '../i18n';
import PageWithHeaderFooter from '../components/PageWithHeaderFooter';
import Subscription from '../scenes/Subscription';
import Unsubscription from '../scenes/Unsubscription';
import AlertFeed from '../scenes/AlertFeed';
import SingleAlert from '../scenes/SingleAlert';

const Main = () => (
  <main style={{ height: '100%' }}>
    <Routes>
      {process.env.REACT_APP_ALERT_FEED_FEATURE === 'true' && <Route path={`${process.env.PUBLIC_URL}/AlertFeed`} element={<PageWithHeaderFooter component={AlertFeed} />} />}
      {process.env.REACT_APP_ALERT_FEED_FEATURE === 'true' && <Route path={`${process.env.PUBLIC_URL}/Alert/:id`} element={<PageWithHeaderFooter component={SingleAlert} />} />}
      <Route path={`${process.env.PUBLIC_URL}/Unsubscription`} element={<PageWithHeaderFooter component={Unsubscription} />} />
      <Route path={`${process.env.PUBLIC_URL}/`} element={<PageWithHeaderFooter component={Subscription} />} />
      <Route path={'*'} element={<PageWithHeaderFooter component={NotFound} />} />
    </Routes>
  </main>
);

const NotFound = () =>
  <div>
    <h1>{i18n.t('404Title')}</h1>
    <p>{i18n.t('404Content')}</p>
  </div>;

export default Main;
